export default class Voucher {
  constructor(API) {
    this.api = API;
  }
  async createVoucher(body, optionalVoucherID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/voucher/' + (optionalVoucherID || 'new');
    req.body = { ...body };
    return await req.exec();
  }
  async updateVoucher(body, voucherID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/voucher/' + voucherID;
    req.body = { ...body };
    return await req.exec();
  }
  async deleteVoucher(voucherID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/voucher/' + voucherID;
    return await req.exec();
  }
  async getVoucher(voucherID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/voucher/' + voucherID;
    return await req.exec();
  }
  async getVouchers(optionalFrom) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/vouchers';
    if (optionalFrom) req.appendQueryParam('from', optionalFrom);
    return await req.exec();
  }
  async verifyVoucher(voucherID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/voucher/${voucherID}/verify`;
    return await req.exec();
  }
}
